import { useDispatch, useSelector } from "react-redux";
import { createChangeRecord } from "../../reducers/depositChangesSlice";
import { selectUser } from "../../reducers/userSlice";
import { selectCompany } from "../../reducers/companySlice";

export const useChangeRecord = () => {
  const dispatch = useDispatch();
  const user = useSelector(selectUser);
  const company = useSelector(selectCompany);

  const recordChange = async ({
    module,
    submodule,
    changes,
    subsidiaryId = "all",
  }) => {
    // Validar que el usuario esté logueado
    if (!user || !user.id) {
      console.error("Usuario no autenticado");
      return;
    }

    // Validar que la compañía esté disponible
    if (!company || !company._id) {
      console.error("Compañía no disponible");
      return;
    }

    // Validar parámetros requeridos
    if (!module || !submodule || !changes || !Array.isArray(changes)) {
      console.error("Parámetros requeridos: module, submodule, changes");
      return;
    }

    try {
      await createChangeRecord(
        {
          user: {
            fullName: `${user.firstName} ${user.lastName}`,
            email: user.email,
            id: user.id,
          },
          companyId: company._id,
          subsidiaryId,
          module,
          submodule,
          changes,
        },
        user.token,
        dispatch
      );
    } catch (error) {
      console.error("Error al crear el registro de cambio:", error);
    }
  };

  return { recordChange };
};

export default useChangeRecord;
